import * as React from 'react';
import { observer } from 'mobx-react';

// Components
import Chip from '../Chip';
import { ITaxonomyTag } from '../TaxonomyCanvas';

// Style
import './TagBar.css';

// Component
export interface IProps {
    tags: ITaxonomyTag[];
    onDelete: (tag: ITaxonomyTag) => void;
}
function TagBar(props: IProps) {
    return (
        <div className="TagBar">
            {props.tags.map(tag => (
                <Chip
                    className="TagBar__chip"
                    key={tag.tagId}
                    label={tag.name}
                    onClick={() => props.onDelete(tag)}
                    onDelete={() => props.onDelete(tag)}
                />
            ))}
        </div>
    );
}

export default observer(TagBar);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TagBar/TagBar.tsx